<ul class="list">
  <li *ngFor="let link of dashboardLinks" class="list-item">
    <button
      class="nav-button"
      kendoButton
      [class.-active]="link.isActive()"
      (click)="onLinkClick(link)"
    >
      {{ link.label }}
    </button>
  </li>
</ul>
